export default __webpack_public_path__ + "static/media/MSWLogo35.e6e1b526.png";